import React from 'react';
import MarkdownText from './index';
import cx from 'classnames';
import styles from './MarkdownContent.module.less';

interface EcmContent {
  content?: string;
  style?: React.CSSProperties;
}

interface MarkdownContentProps {
  ecmContent: EcmContent;
  className?: string;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ ecmContent, className }) => {
  const { content, style } = ecmContent;

  return (
    <div className={cx([styles.container, className])} style={style}>
      <MarkdownText text={content ?? ''} />
    </div>
  );
};

export default MarkdownContent;
